var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegrasprueba2Cropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1926.98 1803.14"
    },
    xmlSpace: "preserve",
    viewBox: "1311.43 1407.59 146.24 135.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1317.76,1512.13v30.92c0,0,21.6-4.7,38.83-24.77c0.14-0.16,0.28-0.32,0.41-0.48    c11.83-13.92,18.21-31.65,18.21-49.92v-52.03c0-4.56-3.7-8.26-8.26-8.26h-47.26c-4.56,0-8.26,3.7-8.26,8.26v44.1    c0,4.56,3.7,8.26,8.26,8.26h24.95C1344.64,1468.21,1348.5,1495.44,1317.76,1512.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1400.22,1512.13v30.92c0,0,21.6-4.7,38.83-24.77c0.14-0.16,0.28-0.32,0.41-0.48    c11.83-13.92,18.21-31.65,18.21-49.92v-52.03c0-4.56-3.7-8.26-8.26-8.26h-47.26c-4.56,0-8.26,3.7-8.26,8.26v44.1    c0,4.56,3.7,8.26,8.26,8.26h24.95C1427.1,1468.21,1430.96,1495.44,1400.22,1512.13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegrasprueba2Cropped);
export default __webpack_public_path__ + "static/media/Negrasprueba2-cropped.b373bcec6f26148f55028349a479eb1c.svg";
export { ForwardRef as ReactComponent };